import React, { useState } from "react";

// Libraries
import InputRange from "react-input-range";

// Components
import Button from "../../components/buttons";

function Slider({ onSubmitAnswer, decimal, meta = false }) {
	const [value, setValue] = useState(5);

	const onChange = (payload) => {
		setValue(payload);
	};

	const submitAnswer = () => {
		onSubmitAnswer(value);
		if (decimal) {
			return;
		}
		setValue(5);
	};

	return (
		<div className="pt">
			<div className="relative mt-m">
				<div className="label label-min">
					{meta && meta[0].content ? meta[0].content : "Oneens"}
				</div>
				<InputRange
					step={1}
					maxValue={10}
					minValue={0}
					value={value}
					onChange={onChange}
				/>
				<div className="label label-max">
					{meta && meta[1].content ? meta[1].content : "Eens"}
				</div>
			</div>
			<Button
				text="Volgende"
				className="mt-m full"
				onClick={submitAnswer}
			></Button>
		</div>
	);
}

export default Slider;
